import { useContext } from "react";
import { Context } from "../Context";

export default function Hero() {
  const context = useContext(Context);
  const discordBotInviteURL = context.urls.discordBotInviteURL;

  return (
    <section className="w-10/12 flex flex-col xl:flex-row lg:w-4/5 py-10 lg:py-20 mx-auto items-center" id="hero">
      <div>
        <h1 className="text-4xl xl:w-4/5 lg:text-7xl font-medium text-left mb-2 max-w-5xl">
          Compete, Track, and Record Your Catches with Fishcord
        </h1>
        <p className="text-lg lg:text-2xl lg:leading-8 text-left mb-5 w-3/4 max-w-2xl">
          A simple way to keep track of all your fish and compete with friends.
          Take photos of every catch, creating memories you can look back at.
        </p>
        <a href={discordBotInviteURL} target="_blank" rel="noopener noreferrer">
          <button className="p-3 text-lg md:p-6 md:text-2xl rounded-lg border bg-black text-primaryColor hover:bg-secondaryColor hover:text-black hover:border-black hover:rounded-none duration-300">
            Add to Server
          </button>
        </a>
      </div>

      <div className="relative mt-8 xl:m-auto overflow-hidden border-8 border-green-700 w-48 sm:w-64 md:w-96 xl:w-[50rem] rounded-full"> 
        <div className="relative w-full aspect-square">
          <img
            className="object-cover w-full h-full"
            src={require("../images/fishcord-logo.png")}
            alt="Fishcord Logo"
          />
        </div>
      </div>
    </section>
  );
}
